export var AccidentState;
(function (AccidentState) {
    AccidentState["HANDLING"] = "HANDLING";
    AccidentState["COMPLETED"] = "COMPLETED";
})(AccidentState || (AccidentState = {}));
